<template>
  <NuxtLayout name="markup" background-class="bg-surface-tertiary">
    <MarkupGenerator :page-data="markupData" :is-page="true" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { general_setPageTheme } from '~/utils/general/pageThemeClassFromMarkup';
import { ASYNC_KEY_FAMILY_PLANS_LISTING } from '~/models/AsyncDataKeys.model';

definePageMeta({
  layout: false,
});
const config = useRuntimeConfig();
const route = useRoute();
const notifications = useNotificationStore();
const familyStore = useFamilyStore();
const { $api } = useNuxtApp();
notifications.reset();
familyStore.initializeDrawerOnFamilyPage();

const { data: markupData, error } = await useAsyncData(
  ASYNC_KEY_FAMILY_PLANS_LISTING,
  async () => {
    return await $api.categoryModule.getCategory(16);
  },
  {
    transform: cache_addFetchedAtTransform,
    getCachedData: cache_getCachedDataFromServer,
  },
);

if (error.value) {
  notifications.setStandardErrorNotification();
}

const canonicalUrl = `${config.public.apiBaseUrl.replace(/\/$/, '')}${route.fullPath.split('?')[0]}`;
general_setPageTheme(markupData.value?.PageContent);

const seoInput = {
  seoData: {
    title: markupData?.value?.MetaTitle,
    description: markupData?.value?.MetaDescription,
    siteName: 'Halebop',
    keywords: markupData?.value?.MetaKeywords,
    canonicalUrl,
  },
  fallBackSeoData: {
    title: 'Familjeabonnemang | Halebop.se',
    description:
      'Fixa Halebop idag, då får du fria SMS till hela världen och massor med surf.  Vi har de senaste Mobiltelefonerna från Apple, Samsung, Nokia, Sony och många fler',
    siteName: 'Halebop',
    keywords: '',
    canonicalUrl,
  },
};
useCustomSeoMeta(seoInput);
</script>

<style scoped lang="scss"></style>
